export default __webpack_public_path__ + "static/media/empty-data-2.f7bb47b1.svg";